import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';

import rootReducer from '../_reducers';
import socketMiddleware from '../_middleware/socketMiddleware';

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
  rootReducer,

  composeEnhancer(applyMiddleware(thunkMiddleware, socketMiddleware)),
);
